import type { IconData } from '@stacksjs/iconify-core'

export const highlighter: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m8.038 11.06l-1.035 3.207l1.776 1.775l3.165-1.077l-3.906-3.906zm1.24-1.59l4.242 4.243l6.364-6.364a2 2 0 0 0 0-2.829L18.47 3.106a2 2 0 0 0-2.829 0L9.277 9.47zm-3.503 6.4L3.88 17.765l1.653 1.151l1.644-1.644zM19.884 1.692l1.414 1.414a4 4 0 0 1 0 5.657l-7.778 7.778l-4.22 1.437l-3.536 3.535L.778 18.04l4.291-4.292L6.45 9.47l7.778-7.778a4 4 0 0 1 5.657 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default highlighter
